import Colors from "assets/Colors";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";
import { formatPhoneNumberIntl } from "react-phone-number-input";

function DocumentPDF({
  data,
  store,
  orderItems,
  nif,
  paymentType,
  currencyFormat,
  t,
}) {
  const date = new Date(data?.creationDatetime);
  const amountReceived = parseFloat(data?.change) + parseFloat(data?.total);

  const regex = /^[0-9]*$/;

  return (
    <Document>
      <Page style={styles.body}>
        <View>
          <View style={styles.headerDrawer}>
            <Text style={styles.headerTitle}>{store?.name}</Text>
            <Text style={styles.headerInfoCompany}>{`NIF ${nif}`}</Text>
            <Text style={styles.headerInfoCompany}>
              {`${store?.address1}, ${store?.zip}`}
            </Text>
            <Text style={styles.headerInfoCompany}>
              {store?.city}
              {store?.city && store?.country && ", "}
              {store?.country}
            </Text>
            <Text style={styles.headerInfoCompany}>
              {store?.phone && `${formatPhoneNumberIntl(store?.phone)}`}
            </Text>
            <Text style={styles.headerInfoDescrition}>
              {moment(date).format("dddd, LL, h:mm a")}
            </Text>
          </View>

          <View style={styles.divider}> </View>
          <View>
            <Text style={[styles.subTitleBill, { textAlign: "center" }]}>
              {data.type === "fac" &&
              (data.subtype === "complete" || data.subtype === "simple")
                ? t(`orders.types.${data.type}${data.subtype}`)
                : t(`orders.types.${data.type}`)}
            </Text>
          </View>
          {/* <View style={styles.divider}> </View> */}

          <View>
            <View style={styles.cols}>
              <Text style={styles.pBill}>
                {t("components.common.Bill.date")}
              </Text>
              <Text style={styles.pBill}>
                {moment(data?.creationDatetime).format("dddd, LL, h:mm a")}
              </Text>
            </View>
            <View style={styles.cols}>
              <Text style={styles.pBill}>
                {t("components.common.Bill.terminal")}
              </Text>
              <Text style={styles.pBill}>{data?.invoiceSerial}</Text>
            </View>
            <View style={styles.cols}>
              <Text style={styles.pBill}>
                {t("components.common.Bill.number")}
              </Text>
              <Text style={styles.pBill}>
                {data?.type === "vou"
                  ? "V-"
                  : `${moment(date).format("YYYY")}-`}
                {data?.invoiceNumber}
              </Text>
            </View>
            <View style={styles.cols}>
              <Text style={styles.pBill}>
                {t("components.common.Bill.attendedBy")}
              </Text>
              <Text style={styles.pBill}>{data?.openUserName}</Text>
            </View>
            {data.customerIdNumber && (
              <View style={styles.cols}>
                <Text style={styles.pBill}>
                  {t("components.common.Bill.customerId")}
                </Text>
                <Text style={styles.pBill}>{data.customerIdNumber}</Text>
              </View>
            )}
            <View style={styles.cols}>
              <Text style={styles.pBill}>
                {t("components.common.Bill.customer")}
              </Text>
              {data?.customerName ? (
                <Text style={styles.pBill}>{data?.customerName}</Text>
              ) : (
                <Text style={styles.pBill}>
                  {t("components.common.Bill.customerName")}
                </Text>
              )}
            </View>
            <View style={styles.cols}>
              {!!data?.customerAddress && (
                <>
                  <Text style={styles.pBill}>
                    {t("components.common.Bill.customerAddress")}
                  </Text>
                  <Text style={styles.pBill}>
                    {data?.customerAddress && data?.customerAddress}
                    {data?.customerAddress2 && `, ${data?.customerAddress2}`}
                    {data?.customerCity && `, ${data?.customerCity}`}
                    {data?.customerZip && `, ${data?.customerZip}`}
                  </Text>
                </>
              )}
            </View>
          </View>

          <View style={styles.divider}> </View>

          <View style={styles.cols}>
            <Text style={[styles.subTitleBill, { width: "33%" }]}>
              {t("components.common.Bill.article")}
            </Text>
            <Text
              style={[
                styles.subTitleBill,
                {
                  width: "33%",
                  textAlign: "center",
                  marginLeft: "35px",
                },
              ]}
            >
              {t("components.common.Bill.quantity")}
            </Text>
            <Text
              style={[
                styles.subTitleBill,
                { width: "33%", textAlign: "right" },
              ]}
            >
              {t("components.common.Bill.price")}
            </Text>
          </View>

          {orderItems.map((item, index) => (
            <View key={index} style={styles.cols}>
              <View style={[styles.pBill, { width: "33%" }]}>
                <Text>{item?.itemName}</Text>
                {!regex.test(item?.barcode) && item?.barcode?.length > 0 && (
                  <Text>({item?.barcode})</Text>
                )}
              </View>
              <Text
                style={[
                  styles.pBill,
                  {
                    width: "33%",

                    textAlign: "center",
                  },
                ]}
              >
                {parseInt(item?.quantity)}
              </Text>
              <Text
                style={[styles.pBill, { width: "33%", textAlign: "right" }]}
              >
                {currencyFormat(item?.baseUnitPrice)}
              </Text>
            </View>
          ))}

          <View style={styles.divider}> </View>

          <View style={styles.cols}>
            <Text style={styles.pBill}>
              {t("components.common.Bill.subTotal")}
            </Text>
            <Text style={styles.pBill}>
              {data?.net && `${currencyFormat(data?.net)}`}
            </Text>
          </View>
          {data?.tax1Imp && (
            <View style={styles.cols}>
              <Text style={styles.pBill}>{data.tax1ImpName}</Text>
              <Text style={styles.pBill}>
                {data?.tax1Imp && `${currencyFormat(data?.tax1Imp)}`}
              </Text>
            </View>
          )}

          <View style={styles.cols}>
            <Text style={styles.pBill}>{data?.tax1Name}</Text>

            <Text style={styles.pBill}>
              {data?.tax1 && `${currencyFormat(data?.tax1)}`}
            </Text>
          </View>

          {/* ********** */}
          {data?.tax2ImpName && (
            <View style={styles.cols}>
              <Text style={styles.pBill}>{data.tax2ImpName}</Text>
              <Text style={styles.pBill}>
                {data?.tax2Imp && `${currencyFormat(data?.tax2Imp)}`}
              </Text>
            </View>
          )}
          {data?.tax2Name && (
            <View style={styles.cols}>
              <Text style={styles.pBill}>{data?.tax2Name}</Text>

              <Text style={styles.pBill}>
                {data?.tax2 && `${currencyFormat(data?.tax2)}`}
              </Text>
            </View>
          )}
          {/* ********* */}
          {/* ********** */}
          {data?.tax3ImpName && (
            <View style={styles.cols}>
              <Text style={styles.pBill}>{data.tax3ImpName}</Text>
              <Text style={styles.pBill}>
                {data?.tax3Imp && `${currencyFormat(data?.tax3Imp)}`}
              </Text>
            </View>
          )}
          {data?.tax3Name && (
            <View style={styles.cols}>
              <Text style={styles.pBill}>{data?.tax3Name}</Text>

              <Text style={styles.pBill}>
                {data?.tax3 && `${currencyFormat(data?.tax3)}`}
              </Text>
            </View>
          )}
          {/* ********* */}
          {/* ********** */}
          {data?.tax4ImpName && (
            <View style={styles.cols}>
              <Text style={styles.pBill}>{data.tax4ImpName}</Text>
              <Text style={styles.pBill}>
                {data?.tax4Imp && `${currencyFormat(data?.tax4Imp)}`}
              </Text>
            </View>
          )}
          {data?.tax4Name && (
            <View style={styles.cols}>
              <Text style={styles.pBill}>{data?.tax4Name}</Text>

              <Text style={styles.pBill}>
                {data?.tax4 && `${currencyFormat(data?.tax4)}`}
              </Text>
            </View>
          )}
          {/* ********* */}

          {data?.extraAmount1 && (
            <View style={styles.cols}>
              <Text style={styles.pBill}>
                {t("components.common.Bill.tip")}
              </Text>

              <Text style={styles.pBill}>
                {currencyFormat(data?.extraAmount1)}
              </Text>
            </View>
          )}

          <View style={styles.cols}>
            <Text style={styles.subTitleBill}>
              {t("components.common.Bill.total")}
            </Text>
            <Text style={styles.pBill}>{currencyFormat(data?.total)}</Text>
          </View>

          <View style={styles.divider}> </View>

          <View>
            <View style={styles.cols}>
              <Text style={styles.pBill}>
                {t("components.common.Bill.paymentType")}
              </Text>
              <Text style={styles.pBill}>{paymentType}</Text>
            </View>
            <View style={styles.cols}>
              <Text style={styles.pBill}>
                {t("components.common.Bill.received")}
              </Text>
              <Text style={styles.pBill}>{currencyFormat(amountReceived)}</Text>
            </View>
            {data.payment === "card" ? null : (
              <View style={styles.cols}>
                <Text style={styles.pBill}>
                  {t("components.common.Bill.change")}
                </Text>
                <Text style={styles.pBill}>{currencyFormat(data?.change)}</Text>
              </View>
            )}
          </View>
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
}

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 20,
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  cols: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },

  divider: {
    borderBottomWidth: 0.5,
    borderBottomColor: Colors.background_dividers,
    marginBottom: 15,
    marginTop: 15,
  },
  headerDrawer: {
    textAlign: "center",
    marginBottom: 0,
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: 500,
    marginBottom: 15,
    marginTop: 15,
  },
  headerInfoCompany: {
    fontSize: 12,
    fontWeight: 300,
    color: Colors.text_secondary,
  },
  headerInfoDescrition: {
    fontSize: 14,
    fontWeight: 300,
    color: Colors.text_primary,
    marginBottom: 10,
    marginTop: 15,
  },
  subTitleBill: {
    fontSize: 12,
    fontWeight: 800,
    color: Colors.text_primary,
  },
  contentBill: {
    display: "flex",
    justifyContent: "center",
  },
  pBill: {
    fontSize: 10,
    fontWeight: 300,
    color: Colors.text_primary,
  },
});

export default DocumentPDF;
